import * as Yup from 'yup';

export const registerValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Must be a valid email.')
    .max(255)
    .required('Email is required.'),
  name: Yup.string()
    .min(2, 'Name should be at least 2 characters long.')
    .max(255)
    .matches(/^[a-zA-Z]/g, 'Name must contains only alphabets.')
    .required('Your name is required.'),
  gymName: Yup.string()
    .min(2, 'Gym Name should be at least 2 characters long.')
    .max(255)
    .required('Gym name is required.'),
  gymAddress: Yup.string()
    .min(2, 'Please enter valid gym address.')
    .max(255)
    .required('Gym address is required.'),
  gymEmail: Yup.string()
    .email('Please enter a valid email.')
    .max(255)
    .optional(),
  currency: Yup.string().required('Currency is required.'),
  gymPhone: Yup.string()
    .min(5, 'Please enter valid gym phone number.')
    .max(12)
    .required('Gym phone number is required.'),
  gymCallingCode: Yup.string().required('Gym calling code is required.'),
  phone: Yup.string().optional(),
  callingCode: Yup.string().optional(),
  password: Yup.string().min(6).max(255).required('Password is required.')
});
